// extracted by mini-css-extract-plugin
export default {"parentClass":"qualified_parentClass__3N3cj","content":"qualified_content__Lgdst","buttons":"qualified_buttons__N0LG8"};